export class Customer {
    CustomerNumber?: string;
    Name?: string;
    FullName?: string;
    StreetAddress?: string;
    City?: string;
    StateProvince?: string;
    PostalCode?: string;
    County?: string;
    Country?: string;
    Latitude?: number;
    Longitude?: number;
    AccountGroup?: string;
    CustomerTypeId?: number;
    PYPayerNumber?: string;
    LinkToSelf?: boolean;
    OpenARBalance?: number;
    PayerName?: string;
    SalesOfficeID?: number;
    SalesOfficeNumber?: string;
    SalesOfficeName?: string;
    Name2?: string;
    Name3?: string;
    Name4?: string;
    POBox?: string;
    POBoxPostalCode?: string;
}

export default Customer;